export default "__VITE_ASSET__D9R2YG8c__"